import { render, staticRenderFns } from "./file-service.vue?vue&type=template&id=1cb30839&"
import script from "./file-service.vue?vue&type=script&lang=ts&"
export * from "./file-service.vue?vue&type=script&lang=ts&"
import style0 from "./file-service.vue?vue&type=style&index=0&id=1cb30839&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports